var _style, _linearGradient, _path, _linearGradient2, _path2, _defs, _clipPath, _g, _defs2, _clipPath2, _linearGradient3, _path3, _g2, _g3, _g4, _g5, _linearGradient4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleAnalyticsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Analytics",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 152.1 152",
    width: 2500,
    height: 2498,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:url(#SVGID_1_)}.st1{fill:url(#SVGID_2_)}.st2{clip-path:url(#SVGID_4_)}.st3{fill:#f57c00}.st4{fill:#ffc107}.st5{clip-path:url(#SVGID_6_);fill:url(#SVGID_7_)}.st6,.st7,.st8,.st9{opacity:.2;clip-path:url(#SVGID_9_);fill:#fff;enable-background:new}.st7,.st8,.st9{clip-path:url(#SVGID_11_)}.st8,.st9{clip-path:url(#SVGID_13_)}.st9{clip-path:url(#SVGID_15_);fill:#bf360c}.st10{fill:url(#SVGID_16_)}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    y1: 77.32,
    x2: 152.1,
    y2: 77.32,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.8 0h-27.7c-6.7 0-12.2 5.5-12.2 12.2V48H59.8C53.3 48 48 53.3 48 59.9V100H11.9C5.3 100 0 105.3 0 111.9v28c0 6.6 5.3 11.9 11.9 12.1h128c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    y1: 77.32,
    x2: 152.1,
    y2: 77.32,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.8 0h-27.7c-6.7 0-12.2 5.5-12.2 12.2V48H59.8C53.3 48 48 53.3 48 59.9V100H11.9C5.3 100 0 105.3 0 111.9v28c0 6.6 5.3 11.9 11.9 12.1h128c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V152h39.7c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 125,
    height: 129,
    xlinkHref: "D219C75C03CDCBF6.png",
    transform: "translate(-9 39)",
    overflow: "visible",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48 60v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h88V48H60c-6.6 0-12 5.4-12 12z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.25,
    y1: 79.07,
    x2: 148.36,
    y2: 4.96,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf360c",
    stopOpacity: 0.02
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M100 48v104h39.7c6.7 0 12.2-5.5 12.2-12.2V100L100 48z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_8_",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M60 49h40v-1H60c-6.6 0-12 5.4-12 12v1c0-6.6 5.4-12 12-12z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_10_",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12 101h36v-1H12c-6.6 0-12 5.4-12 12v1c0-6.6 5.4-12 12-12z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_12_",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2v1c0-6.7 5.5-12.2 12.2-12.2h27.5c6.7 0 12.2 5.5 12.2 12.2v-1C152 5.5 146.5 0 139.8 0z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_14_",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M139.8 151H12c-6.6 0-12-5.4-12-12v1c0 6.6 5.4 12 12 12h127.7c6.7 0 12.2-5.5 12.2-12.2v-1c.1 6.7-5.4 12.2-12.1 12.2z"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.969,
    y1: 102.289,
    x2: 149.295,
    y2: 3.963,
    gradientTransform: "matrix(1 0 0 -1 0 153.32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M139.8 0h-27.5c-6.7 0-12.2 5.5-12.2 12.2V48h-40c-6.6 0-12 5.4-12 12v40H12c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h127.8c6.7 0 12.2-5.5 12.2-12.2V12.2C152 5.5 146.5 0 139.8 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAnalyticsLogo);
export default __webpack_public_path__ + "static/media/google-analytics-logo.afebf6441fc7e1eaccd3791df1c2e43a.svg";
export { ForwardRef as ReactComponent };